import { useEffect, useState} from 'react';
import { producaov2 } from '../../services/apis';

export default function useUserInfo({ userID }) {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await producaov2.get(`/admin/pessoas/${userID}/basic`, {
          headers: {
            access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
          }
        });

        setData({
          id: response.data.id,
          name: response.data.nome,
          email: response.data.email
        });
      } catch(error) {
        if(error?.response) {
          setError(error?.response?.data?.message);
          return;
        }

        setError(error?.message);
      } finally {
        setIsLoading(false);
      }
    }

    getUser();
  }, []);

  return {
    data,
    isLoading,
    error
  }
}